import { roundMoney } from './moneyFormat';

export function isBelowConfiguredBillingRate(displayRate) {
    return Number(displayRate) <= 0;
}

/** Pre-credit estimate amount (points × rate, or base service fee for unprocessed). */
export function getEstimateGrossTotal({
    isProcessed,
    pointTypeTotal,
    specialPointTypeTotal,
    displayRate,
    baseServiceFee,
}) {
    if (isProcessed == 1) {
        return roundMoney((Number(pointTypeTotal) + Number(specialPointTypeTotal)) * Number(displayRate));
    }
    return roundMoney(Number(baseServiceFee));
}

/** True when a non-zero credit is present without a description of why. */
export function isMissingCreditDescription(planCredit, creditReason) {
    return Number(planCredit) !== 0 && !String(creditReason ?? '').trim();
}
